import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react'
import cx from 'classnames'

interface Props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: React.ReactNode
}

export const MarketingButton = forwardRef<HTMLButtonElement, Props>(
  ({ className = '', ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={cx(
          'text-white text-lg marketing-button text-center whitespace-nowrap flex items-center font-medium leading-6 gotham rounded-md transition duration-300 ease-in-out sm:mt-0 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto focus:outline-none focus:ring',
          className,
        )}
        style={{
          padding: '14px 17px',
          backgroundColor: 'rgba(0,0,0,.7)',
          mixBlendMode: 'overlay',
        }}
        {...rest}
      />
    )
  },
)
